import adminApi from '../../apis/adminApi';

export function addBenefit(values) {
  return adminApi.post('/api/admin/benefits', values).then((res) => res.data);
}

export function getBenefits() {
  return adminApi.get('/api/admin/benefits').then((res) => res.data);
}

export function getBenefit(id) {
  return adminApi.get(`/api/admin/benefits/${id}`).then((res) => res.data);
}

export function editBenefit(id, values) {
  return adminApi.put(`/api/admin/benefits/${id}`, values).then((res) => res.data);
}

export function deleteBenefit(id) {
  return adminApi.delete(`/api/admin/benefits/${id}`).then((res) => res.data);
}
